<h4 class="grid-header">{{TR "Parametrierung"}}</h4>
{{> WARNING_HINTS}}
{{#if valuesComplete}}
{{#each heatCircuits}}
<div class="card-box js-parameter-container {{#if this.isInconsistent}}highlight{{else}}bg-white{{/if}}">
	<div class="grid-header">
		{{#if this.attributes.canEdit}}
		<button id="edit-circuit-{{this.attributes.circuitNr}}" class="js-edit btn btn-white pull-right"><i class="js-edit-icon {{#if this.attributes.isInconsistent}}fa fa-hourglass{{else}}glyphicon glyphicon-pencil{{/if}}"></i></button>
		{{/if}}
		<h4>{{this.attributes.name}}{{#if this.attributes.mode}} ({{this.attributes.mode}}){{/if}}</h4>
	</div>
	<div id="circuit-{{this.circuitNr}}"></div>
</div>
{{/each}}
{{else}}
	{{> MESSAGE errorMessage}}
{{/if}}
